var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicklistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4618 15.7692C18.8849 15.7692 19.2311 15.4231 19.2311 15V5C19.2311 4.57693 18.8849 4.23077 18.4618 4.23077H1.53876C1.11569 4.23077 0.769531 4.57693 0.769531 5V15C0.769531 15.4231 1.11569 15.7692 1.53876 15.7692H18.4618ZM2.30799 14.2308V5.76924H17.6926V14.2308H2.30799Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 8.84616H16.0767C16.1921 8.84616 16.2306 8.96155 16.1536 9.03847L14.3844 11.0769C14.3075 11.1539 14.1921 11.1539 14.1152 11.0769L12.3459 9.03847C12.3075 8.96155 12.3844 8.84616 12.4998 8.84616Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicklistIcon);
export default __webpack_public_path__ + "static/media/picklist-icon.16a7a8b96e1260c950ff5892d2999c97.svg";
export { ForwardRef as ReactComponent };